import React from 'react';

/**
 * Labelled Bootstrap select.
 *
 * `options` accepts either a plain string array (value === label) or an
 * array of `{ value, label }` objects.
 */
export default function SelectInput({
  id,
  label,
  value,
  onChange,
  options = [],
  required = false,
  placeholder = 'Select…',
  help,
  error,
  col = 'col-md-6',
  disabled = false,
}) {
  const normalized = options.map((opt) => (
    typeof opt === 'string' ? { value: opt, label: opt } : opt
  ));

  return (
    <div className={col}>
      <label htmlFor={id} className="form-label">
        {label}
        {required && <span className="text-danger"> *</span>}
      </label>
      <select
        id={id}
        className={`form-select${error ? ' is-invalid' : ''}`}
        value={value ?? ''}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">{placeholder}</option>
        {normalized.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {help && <div className="form-text">{help}</div>}
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
}
